import { Component, OnInit } from "@angular/core";
import { DropEvent } from "ng-drag-drop";
import { Router } from "@angular/router";
// import { routing } from '../app.routing';

// import { NgbdModalConfigAnjalis } from "../modals/modal-basic-anjalis";

@Component({
  selector: "app-anjalis-quiz",
  templateUrl: "./anjalis-quiz.component.html",
  styleUrls: ["./anjalis-quiz.component.css"]
})
export class AnjalisQuizComponent implements OnInit {
  user: any;
  constructor(private router: Router) {}

  questions: string[] = [
    "Hvor mange gange dumpede Anjalis far 3. klasse?",
    "Hvorfor kunne Anjali godt lide den tid, hvor hendes far arbejdede i Saudi Arabien?",
    "Hvor mange af Anjalis venner går stadig i skole?",
    "Hvad kan Anjali lide at lave i sin fritid?",
    "Hvorfor må Anjali ikke besøge venner udenfor landsbyen?"
  ];

  correctAns: string[] = [
    "3 gange",
    "Der var ingen vold og skænderier",
    "Ingen",
    "Danse",
    "Hendes mor er bange for, at hun vil stikke af",
    "She-Phoksundo"
  ];

  i: number = 0;
  score: number = 0;
  indexes: any;
  finished: boolean;
  vegetables = [
    [
      { name: "1 gang", type: "vegetable" },
      { name: "2 gange", type: "vegetable" },
      { name: "3 gange", type: "vegetable" }
    ],
    [
      { name: "Han ringede hjem hver dag", type: "vegetable" },
      { name: "Der var ingen vold og skænderier", type: "vegetable" },
      { name: "Hun fik lækkert tøj", type: "vegetable" }
    ],
    [
      { name: "En pige mere", type: "vegetable" },
      { name: "To piger", type: "vegetable" },
      { name: "Ingen", type: "vegetable" }
    ],
    [
      { name: "Danse", type: "vegetable" },
      { name: "Synge", type: "vegetable" },
      { name: "Læse", type: "vegetable" }
    ],
    [
      {
        name: "Hendes mor er bange for, at hun vil løbe væk",
        type: "vegetable"
      },
      { name: "Vennerne vil ikke have hende på besøg", type: "vegetable" },
      { name: "Hun har ingen venner", type: "vegetable" }
    ]
  ];

  fruits = [
    { name: "Apple", type: "fruit" },
    { name: "Orange", type: "fruit" },
    { name: "Mango", type: "fruit" },
    { name: "Banana", type: "fruit" }
  ];

  droppedFruits = [];
  droppedVegetables = [];
  droppedItems = [];
  fruitDropEnabled = true;
  dragEnabled = true;

  onFruitDrop(e: DropEvent) {
    this.droppedFruits.push(e.dragData);
    this.removeItem(e.dragData, this.fruits);
  }

  onVegetableDrop(e: DropEvent) {
    this.droppedVegetables.push(e.dragData);
    console.log(e.dragData.name);
    if (e.dragData.name == this.correctAns[this.i]) {
      this.score++;
    }
    // this.removeItem(e.dragData, this.vegetables);
    this.i++;
    // this._db.list("users").set(this._auth.userDetails.uid, {user: this.user, score: this.score});

    this.indexes = this.vegetables[this.i];
    if (this.questions.length == this.i) {
      this.finished = true;
      this.router.navigate(["/dilema-game"]);
    }
  }

  onAnyDrop(e: DropEvent) {
    this.droppedItems.push(e.dragData);

    if (e.dragData.type === "vegetable") {
      this.removeItem(e.dragData, this.vegetables);
    } else {
      this.removeItem(e.dragData, this.fruits);
    }
  }

  removeItem(item: any, list: Array<any>) {
    let index = list
      .map(function(e) {
        return e.name;
      })
      .indexOf(item.name);
    list.splice(index, 1);
  }

  ngOnInit() {
    // this.openModal.nativeElement.click();
  }
}
